import * as Converter from "./converter";

import type * as Type from "./type";
import type * as Repository from "../../_repository";

type Props = {
	viewModel: Type.ViewModel;
	// 検索日
	searchDate: string;
	// オプションリスト
	optionPmsActiveListQueryData: Repository.Query.QueryData.OptionPmsList.OptionPmsActiveListQueryData;
	// オプションカラーリスト
	optionPmsColorListQueryData: Repository.Query.QueryData.OptionPmsColorListQueryData;
};
type Result = {
	viewData: Type.ViewData;
};

export const useViewData = ({
	viewModel,
	searchDate,
	optionPmsColorListQueryData,
	optionPmsActiveListQueryData,
}: Props): Result => {
	/**
	 * ViewData への変換
	 */
	const { viewData } = Converter.useViewDataConverter({
		viewModel,
		searchDate,
		optionPmsColorListQueryData,
		optionPmsActiveListQueryData,
	});

	return {
		viewData,
	};
};
